import React from 'react';

import type { LunaClient } from '@vlabs/api-bindings/src';
import { apiContainer } from '@vlabs/api-bindings/src';
import { routes } from '@vlabs/shared/navigation/routes';
import { useModal } from '@vlabs/uikit';
import qs from 'qs';
import { generatePath, useHistory } from 'react-router-dom';

import { ImageCheckForm } from './ImageCheckForm';
import type { TImageCheckFormValues, TImageCheckFormSubmitValues } from './types';

interface UseImageCheckFormProps extends TImageCheckFormValues {
  fileList?: FileList;
  liveness: boolean;
  deepfake: boolean;
  iso: boolean;
  icao: boolean;
  mindigital: boolean;
}

interface TClickableControl {
  onClick: VoidFunction;
}
interface UseImageCheckFormReturn {
  wrap: (Component: React.JSXElementConstructor<TClickableControl>) => React.JSX.Element;
}

function useImageCheckForm(formProps?: UseImageCheckFormProps): UseImageCheckFormReturn {
  const modal = useModal();
  const history = useHistory();

  const lunaClient = (apiContainer.lunaClient as LunaClient);
  const onSubmit = async ({ fileList: file, ...checks }: TImageCheckFormSubmitValues) => {
    const resp = await lunaClient.objects.create(file[0], {
      headers: {
        'Content-type': (file[0] as File).type,
      },
    });
    const objectId = resp.data.object_id;
    const route = generatePath(routes.checks.imageChecks, { objectId });
    const queryParams = qs.stringify({ ...checks, filename: (file[0] as File).name });
    history.push(`${route}?${queryParams}`);
  };

  return {
    wrap: (Component: React.JSXElementConstructor<TClickableControl>): React.JSX.Element => {
      return (
        <React.Fragment>
          {modal.wrap(<ImageCheckForm
            {...formProps}
            onCancel={modal.close}
            onSubmit={onSubmit}
          />)}
          <Component onClick={modal.open} />
        </React.Fragment>
      );
    },
  };
}

export { useImageCheckForm };
